import {Component, Injector, OnInit} from "@angular/core";
import {
    APPLICATION_SCOPE_TYPE,
    ITCIAppCustomizationParam,
    ITCIAppFeatureService,
    ITCIApplication,
    ITCIApplicationAuth,
    ITCITenantComponentOptions,
    ITCIUserInfo,
    TCI_APP_CUSTOMIZATION_TYPE,
    TCI_APP_DETAIL_MENU_TYPE,
    TCI_COMPONENT_MODE,
    TCITenantAppType,
    TCITenantSelectorType,
    ITCIEnvVars
} from "@tci/common";

import {
    ITCIAppDetailsUserTimestampComponentInput,
    ITCIAppDetailsUserTimestampComponentOutput,
    TCITenantComponentInput,
    TCITenantComponentOutput
} from "../../ng-tenant/tci-tenant-components";
import {AbstractTCITenantComponent} from "../../ng-tenant/tci-tenant-component";
import {NgUserService} from "../../ng-shared/ng-services/ng-user.service";
import {Observable} from "rxjs";
import {NgAppFeatureToggleService} from "../../ng-shared/ng-services/ng-app-feature-toggle.service";
import {NgCustomizationProviderService} from "@tci/core";
import {NgEnvVarsService} from "../../ng-shared/ng-services/ng-env-vars.service";

/**
 * BaseAppDetailUserTimestampComponentInput
 */
export class BaseAppDetailUserTimestampComponentInput extends TCITenantComponentInput
    implements ITCIAppDetailsUserTimestampComponentInput {

    // Custom Configs
    private CUSTOM_TYPES = TCI_APP_CUSTOMIZATION_TYPE;
    private customConfig: { [key: string]: ITCIAppCustomizationParam } = {};

    /**
     *
     * @param tenantAppType
     * @param componentSelector
     * @param application
     * @param userService
     * @param featureToggleService
     * @param defCustomSvc
     * @param mode
     * @param componentOption?
     */
    constructor(
        public tenantAppType: TCITenantAppType,
        public componentSelector: TCITenantSelectorType,
        public application: ITCIApplication,
        public userService: NgUserService,
        public featureToggleService: NgAppFeatureToggleService,
        private defCustomSvc: NgCustomizationProviderService,
        public mode: TCI_COMPONENT_MODE | string,
        public componentOption?: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>) {
        super();
        if (!mode) {
            this.mode = TCI_COMPONENT_MODE.COMP_MODE_APP_DEFAULT;
        }

        // FE Custom Config Setup
        this.getCustomConfig();
    }


    getApplication(): ITCIApplication {
        return this.application;
    }

    getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth> {
        return this.userService.getAuthForFunction(scope);
    }

    getUserInfo(): Observable<ITCIUserInfo> {
        return this.userService.getUserInfo(false);
    }


    getFeatureToggleService(): ITCIAppFeatureService {
        return this.featureToggleService;
    }

    getEnvVar(injector: Injector, ...envVarNames: string[]): Observable<ITCIEnvVars<any>> {
        return (<NgEnvVarsService>injector.get(NgEnvVarsService)).getEnvVar(...envVarNames);
    }

    // Customizer
    private getCustomConfig() {
        const appDetailCustomTypes = [
            this.CUSTOM_TYPES.APP_DETAIL_HEADER_CREATED_BY
        ];
        const customConfigObs: Observable<ITCIAppCustomizationParam>[] = appDetailCustomTypes.map(customType => {
            // Prepare observables to get the config of each type
            return this.defCustomSvc
                .getCustomizations({
                    type: customType
                })
                .map(custom => custom.success ? custom.result : null)
                .map((customParam: ITCIAppCustomizationParam) => {
                    if (customParam) {
                        this.customConfig[customType] = customParam;
                    }
                    return customParam;
                });
        });

        // Request the custom configuration
        Observable.merge(...customConfigObs)
            .take(appDetailCustomTypes.length)
            .toArray()
            .subscribe(() => {});
    }

    getCustomVisible(type: TCI_APP_CUSTOMIZATION_TYPE): boolean {
        const custom = this.customConfig[type];
        if (!custom) {
            return false;
        }
        return this.customConfig[type].enabled && this.customConfig[type].visible;
    }
}

export class BaseAppDetailUserTimestampComponentOutput<E> extends TCITenantComponentOutput<E> {
    constructor() {
        super();
    }
}

@Component({
    selector: TCITenantSelectorType.TCI_APP_DETAIL_USER_TIMESTAMP.toString(),
    templateUrl: "./base-app-user-timestamp.component.html",
    styleUrls: ["./base-app-user-timestamp.component.less"]
})
export class BaseAppUserTimestampComponent<E, I extends BaseAppDetailUserTimestampComponentInput,
    O extends BaseAppDetailUserTimestampComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O>
    implements OnInit {

    private CUSTOM_TYPES = TCI_APP_CUSTOMIZATION_TYPE;

    constructor() {
        super();
    }

    ngOnInit(): void {
    }

    showCreatedBy() {
        return this.input.getCustomVisible(this.CUSTOM_TYPES.APP_DETAIL_HEADER_CREATED_BY);
    }
}
